import { render, staticRenderFns } from "./Nopage.vue?vue&type=template&id=f0995314&scoped=true"
import script from "./Nopage.vue?vue&type=script&lang=js"
export * from "./Nopage.vue?vue&type=script&lang=js"
import style0 from "./Nopage.vue?vue&type=style&index=0&id=f0995314&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0995314",
  null
  
)

export default component.exports